import { formatCount } from "@common/lib/number"
/**
 * Split text on punctuation marks into sentences
 * One minor thing we do is avoid splitting on Ch. / No. - a common abbrev
 * or any punctuation following an uppercase letter.
 */
export function splitSentences(text: string): string[] {
  return text
    .split(/(?<!(?:[Cc]h|[Nn]o)\.)(?<=[^A-Z][.!?])\s+/)
    .filter((t) => !!t)
}

export function joinWithAnd(items: string[]): string {
  return items.length > 1
    ? `${items.slice(0, -1).join(", ")} and ${items.at(-1)}`
    : items.join("")
}

export function sentenceCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export function plural(count: number, noun: string): string {
  return `${formatCount(count)} ${noun}${count === 1 ? "" : "s"}`
}
